<div class="indicators">
  <mat-icon [inline]="true" [class]="'first ' + type">stop_circle</mat-icon>
  <mat-icon [inline]="true" [class]="'second ' + type ">stop_circle</mat-icon>
  <mat-icon [inline]="true" [class]="'third ' + type">stop_circle</mat-icon>
</div>
